import {contentVisualPreviewImageElement} from '@cohort/components-xps/components/contents/apps/utils';
import type {MediaSize} from '@cohort/shared/utils/media';
import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import {XLogo} from '@phosphor-icons/react';

type TwitterPostVisualPreviewContentProps = {
  imageFileKey: string | null;
  imageSize: MediaSize;
  title: string;
  isMobile: boolean;
  className?: string;
};

const TwitterPostVisualPreviewContent: React.FC<TwitterPostVisualPreviewContentProps> = ({
  imageFileKey,
  imageSize,
  isMobile,
  title,
  className,
}) => {
  if (!imageFileKey) {
    return (
      <div className={cn('flex h-full', isMobile ? 'justify-center' : 'items-center justify-end')}>
        <XLogo
          size={isMobile ? 225 : 180}
          className={cn('text-inherit opacity-30')}
          {...(!isMobile ? {viewBox: '40 25 120 200'} : {})}
        />
      </div>
    );
  }

  const imageSrc = getImageUrl(import.meta.env.COHORT_ENV, imageFileKey, {
    h: Sizes[imageSize],
    w: Sizes[imageSize],
  });

  return contentVisualPreviewImageElement(title, imageSrc, className);
};

export default TwitterPostVisualPreviewContent;
